/* Mobile Menu JavaScript */

// Mobile menu toggle
const hamburgerMenu = document.querySelector('.hamburger-menu');
const mobileMenuOverlay = document.querySelector('.mobile-menu-overlay');
const mobileMenuClose = document.querySelector('.mobile-menu-close');
const body = document.body;

// Open mobile menu
if (hamburgerMenu) {
    hamburgerMenu.addEventListener('click', () => {
        mobileMenuOverlay.classList.add('active');
        body.style.overflow = 'hidden'; // Prevent body scroll
    });
}

// Close mobile menu
if (mobileMenuClose) {
    mobileMenuClose.addEventListener('click', () => {
        mobileMenuOverlay.classList.remove('active');
        body.style.overflow = ''; // Restore body scroll
    });
}

// Close menu when clicking on overlay backdrop
if (mobileMenuOverlay) {
    mobileMenuOverlay.addEventListener('click', (e) => {
        if (e.target === mobileMenuOverlay) {
            mobileMenuOverlay.classList.remove('active');
            body.style.overflow = '';
        }
    });
}

// Text banner rotation
const bannerTexts = document.querySelectorAll('.banner-text');
let currentBannerIndex = 0;

function rotateBanner() {
    if (bannerTexts.length === 0) return;

    // Remove active class from current
    bannerTexts[currentBannerIndex].classList.remove('active');

    // Move to next banner
    currentBannerIndex = (currentBannerIndex + 1) % bannerTexts.length;

    // Add active class to new banner
    bannerTexts[currentBannerIndex].classList.add('active');
}

// Rotate banner every 3 seconds
if (bannerTexts.length > 0) {
    setInterval(rotateBanner, 3000);
}
